<template>
    <div class="org-desc">
        <div class="org-nav">
            <div v-for="item in leftNav" :key="item.active" :class="{active:item.active == active}" class="item" @click="go(item.page)">
                <i class="icon iconfont" :class="item.icon"></i>
                <b>{{ item.name }}</b>
                <img v-if="item.active == active" alt="" class="jiantou" src="@/assets/images/jiantounav.png">
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: "leftPage",
    data() {
        return {
            leftNav: [
                {
                    name: '操作日志',
                    icon: 'icon-zhengxinxinxi',
                    active: 3,
                    page: '/admin/log'
                },
                {
                    name: '密码管理',
                    icon: 'icon-mima',
                    active: 2,
                    page: '/admin/password'
                },
            ]
        }
    },
    props: {
        active: {
            type: [String, Number],
            default: ''
        }
    },
    computed: {

    },
    components: {},
    created() {
        this.init()
    },
    methods: {
        async init() {
            if (!this.$store.state.user.pid){
                this.leftNav.unshift({
                    name: '账号管理',
                    icon: 'icon-zhanghao1',
                    active: 1,
                    page: '/admin/account'
                })
            }
        },

        go(path) {
            this.$router.push({
                path: path
            })
            // }
        },
    },
    watch: {},
    filters: {}
}
</script>

<style lang="scss" scoped>
.org-desc {
    min-height: calc(100vh - (173px + 199px));
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    height: 100%;
    flex-shrink: 0;
    width: 260px;
    .org-nav {
        flex: 1;
        width: 100%;
        //background: #2791ff;
        background-image: linear-gradient(0deg,
            #7eb6ff 0%,
            #2791ff 100%);
        border-radius: 10px;

        .item {
            width: 100%;
            height: 100px;
            border-bottom: 1px solid rgba(255, 255, 255, .4);
            display: flex;
            align-items: center;
            position: relative;
            cursor: pointer;
            padding-left: 25px;

            &.active {
                background: rgba(255, 255, 255, .25);
            }

            .icon {
                margin-right: 15px;
                font-size: 26px;
                color: #ffffff;
                text-shadow: 0px 0px 13px 0px
                rgba(0, 102, 208, 0.43);
            }

            b {
                font-weight: normal;
                font-size: 20px;
                color: #ffffff;
            }

            .jiantou {
                position: absolute;
                top: 45px;
                right: -8px;
            }
        }
    }

    .org-detail {
        width: 100%;
        height: 220px;
        background-color: #2791ff;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding: 20px;

        .org-name {
            width: 100%;
            text-align: center;
            font-size: 18px;
            color: #ffffff;
            padding-top: 15px;
        }

        .org-head {
            width: 68px;
            height: 68px;
            border-radius: 34px;
            margin: 0 auto;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
}
</style>


